/* tslint:disable */
/* eslint-disable */
/**
 * Magnolia Headless Helper API
 * Helper API and model definitions for breadcrumbs page navigation etc. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiBreadCrumbResponse,
    ApiBreadCrumbResponseFromJSON,
    ApiBreadCrumbResponseFromJSONTyped,
    ApiFormSubmitRequest,
    ApiFormSubmitRequestFromJSON,
    ApiFormSubmitRequestFromJSONTyped,
    ApiFormSubmitResponse,
    ApiFormSubmitResponseFromJSON,
    ApiFormSubmitResponseFromJSONTyped,
    ApiPage,
    ApiPageFromJSON,
    ApiPageFromJSONTyped,
} from '../models';

export interface DefaultApiGetBreadCrumbNodesRequest {
    pageId: string;
    lang: string;
}

export interface DefaultApiGetPageNavRequest {
    rootPath: string;
    lang: string;
}

export interface DefaultApiSubmitFormRequest {
    apiFormSubmitRequest: ApiFormSubmitRequest;
}

/**
 * no description
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Get breadcrumb elements
     */
    async getBreadCrumbNodesRaw(requestParameters: DefaultApiGetBreadCrumbNodesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiBreadCrumbResponse>> {
        if (requestParameters.pageId === null || requestParameters.pageId === undefined) {
            throw new runtime.RequiredError('pageId','Required parameter requestParameters.pageId was null or undefined when calling getBreadCrumbNodes.');
        }

        if (requestParameters.lang === null || requestParameters.lang === undefined) {
            throw new runtime.RequiredError('lang','Required parameter requestParameters.lang was null or undefined when calling getBreadCrumbNodes.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.pageId !== undefined) {
            queryParameters['pageId'] = requestParameters.pageId;
        }

        if (requestParameters.lang !== undefined) {
            queryParameters['lang'] = requestParameters.lang;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/breadcrumb`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiBreadCrumbResponseFromJSON(jsonValue));
    }

    /**
     * Get breadcrumb elements
     */
    async getBreadCrumbNodes(pageId: string, lang: string, initOverrides?: RequestInit): Promise<ApiBreadCrumbResponse> {
        const response = await this.getBreadCrumbNodesRaw({ pageId: pageId, lang: lang }, initOverrides);
        return await response.value();
    }

    /**
     * Get page nav elements
     */
    async getPageNavRaw(requestParameters: DefaultApiGetPageNavRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiPage>>> {
        if (requestParameters.rootPath === null || requestParameters.rootPath === undefined) {
            throw new runtime.RequiredError('rootPath','Required parameter requestParameters.rootPath was null or undefined when calling getPageNav.');
        }

        if (requestParameters.lang === null || requestParameters.lang === undefined) {
            throw new runtime.RequiredError('lang','Required parameter requestParameters.lang was null or undefined when calling getPageNav.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.lang !== undefined) {
            queryParameters['lang'] = requestParameters.lang;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/pagenav/{rootPath}`.replace(`{${"rootPath"}}`, encodeURIComponent(String(requestParameters.rootPath))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiPageFromJSON));
    }

    /**
     * Get page nav elements
     */
    async getPageNav(rootPath: string, lang: string, initOverrides?: RequestInit): Promise<Array<ApiPage>> {
        const response = await this.getPageNavRaw({ rootPath: rootPath, lang: lang }, initOverrides);
        return await response.value();
    }

    /**
     * Submit a form to the CMS
     */
    async submitFormRaw(requestParameters: DefaultApiSubmitFormRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiFormSubmitResponse>> {
        if (requestParameters.apiFormSubmitRequest === null || requestParameters.apiFormSubmitRequest === undefined) {
            throw new runtime.RequiredError('apiFormSubmitRequest','Required parameter requestParameters.apiFormSubmitRequest was null or undefined when calling submitForm.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/form/submit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApiFormSubmitRequestFromJSONTyped(requestParameters.apiFormSubmitRequest, false),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiFormSubmitResponseFromJSON(jsonValue));
    }

    /**
     * Submit a form to the CMS
     */
    async submitForm(apiFormSubmitRequest: ApiFormSubmitRequest, initOverrides?: RequestInit): Promise<ApiFormSubmitResponse> {
        const response = await this.submitFormRaw({ apiFormSubmitRequest: apiFormSubmitRequest }, initOverrides);
        return await response.value();
    }

}

// custom code here ##################################################################################################################
// function toUTC(date) {
//   var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
//   return new Date(date_utc);
// }
